import Router from 'next/router'
import Icon from 'antd/lib/icon'

class Logout extends React.Component {

  logout = () => {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('activeMenu')
    localStorage.removeItem('theme')
    console.log('Logout...')
    Router.push('/login')
    // window.location.href = `${process.env.SITE_NAME}/login`
    window.location.href = `/login`
  }

  render() {
    return (
      <a className="logout" onClick={ this.logout }>
        <Icon type="poweroff" />
      </a>
    )
  }
}

export default Logout